import { render, staticRenderFns } from "./custom-objective-type.vue?vue&type=template&id=1c533a40&scoped=true&"
import script from "./custom-objective-type.vue?vue&type=script&lang=js&"
export * from "./custom-objective-type.vue?vue&type=script&lang=js&"
import style0 from "./custom-objective-type.vue?vue&type=style&index=0&id=1c533a40&scoped=true&lang=scss&"
import style1 from "./custom-objective-type.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c533a40",
  null
  
)

export default component.exports